import { Form, FormLongTextInput, FormMultiSelectInput, FormTextInput } from '@superhi/design'
import React from 'react'

import { API } from '../../../../../api'
import BaseForm from '../../../_templates/BaseForm'

import { FormValues } from './types'
import { FIELDS, VALIDATION_SCHEMA } from './config'
import MUTATION from './mutations'

const CourseLessonsCreate: React.FC<React.PropsWithChildren<unknown>> = () => (
  <BaseForm<FormValues, API.course_lessons_create_mutationVariables>
    mutation={MUTATION}
    validationSchema={VALIDATION_SCHEMA}
    initialValues={{
      wistiaVideoId: '',
    }}
    createVariablesFn={(values) => ({
      ...values,
    })}
  >
    <Form.Rows>
      <FormTextInput {...FIELDS.WISTIA_VIDEO_ID} />
    </Form.Rows>
  </BaseForm>
)

export default CourseLessonsCreate
